export default __webpack_public_path__ + "mixvibes-cross.bbb5907c.png";